export default {
  data () {
    return {
      isPosting: false,
      stackFunc: [],
      timer: null
    }
  },
  methods: {
    beginPost () {
      this.isPosting = true
    },
    endPost () {
      this.isPosting = false
    },
    async avoidMultipost (func) {
      if (this.isPosting) {
        // タイマーが仕掛けられている場合は古いタイマーをクリアする
        if (this.timer) {
          clearTimeout(this.timer)
        }
      }
      this.beginPost()

      let res = null
      this.timer = setTimeout(() => {
        res = func()
        this.endPost()
        return res
      }, 500)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/MultipostAvoidableMixin.js